import React, {useState, useRef} from "react";
import assets from "../assets/imgs";


function SearchExtra(){
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const searchRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState('');   

  const handleSearchFocus = () => {
    setIsSearchFocused(true);
    if (searchRef.current) {
      searchRef.current.focus();
    }
  };

  const handleSearchBlur = () => {
    setIsSearchFocused(false);
  };

  return(
    <div style={styles.searchInput} onClick={handleSearchFocus}>
      {!isSearchFocused && (
        <assets.icons.search
          style={{
            color: "var(--grayscale_cool_80)",
          }}
        />
      )}
      <input
        ref={searchRef}  
        type="text"
        placeholder={isSearchFocused ? "" : "원하는 메뉴를 검색해보세요."}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value) }
        onFocus={handleSearchFocus} // 포커스 상태 관리
        onBlur={handleSearchBlur} // 포커스 해제 시 상태 초기화
        className="font-body3-semibold" 
        style={{color:"var(--text-color_50)", border: "none", outline: "none", flex: "1",
          backgroundColor: "transparent",
        }}
      />
    </div>
  );
}

function WriteExtra({text, onClick, onRed = true}){
  return(
    <div style={onRed ? styles.redButton : styles.whiteButton} className="font-body2-semibold" onClick={onClick}>
      {text}
    </div>
  );
}

const styles ={
  searchInput:{
    padding: '12px', width: '270px' , height: "45px", borderRadius: "8px", gap: "10px",
    boxSizing: "border-box", border: "1px solid var(--grayscale-cool_40)", background: "var(--grayscale-cool_20)",
    display: "flex", justifyContent: "flex-start", alignItems: "center", cursor: "text"
  },
  redButton:{
    width: "150px",
    height: "48px",
    backgroundColor: "var(--primary-crimson_40)",
    color: "white",
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: "8px",
  },
  whiteButton:{
    width: "150px",
    height: "48px",
    backgroundColor: "white",
    border: "1px solid var(--primary-crimson_40)",
    color: "var(--primary-crimson_40)",
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: "8px",
  }
}

const HeaderExtra ={
  SearchExtra, WriteExtra,
}
export default HeaderExtra;